import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetMeetingListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    columnChooser: ColumnChooserModel[] | undefined
    meetingDateStart: string | undefined
    meetingDateEnd: string | undefined
    selectedCustomer: CustomSingleSelectModel | undefined
    selectedMeetingTypes: CustomMultiSelectModel[]
    selectedMeetingCompanyTypes: CustomMultiSelectModel[]
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetMeetingListPagingAndFilterRequest: GetMeetingListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    // Tarih ve firma durumu varsayılanları artık kolon filtresi (MeetingList açılışında kurulur).
    meetingDateStart: undefined,
    meetingDateEnd: undefined,
    selectedCustomer: undefined,
    selectedMeetingTypes: [],
    selectedMeetingCompanyTypes: [],
    columnFilters: []
}